// eslint-disable-next-line import/no-extraneous-dependencies
import { validate } from './JoyDocValidator.js';
import JoyDocSchemaJson from '../constants/JoyDocSchema.json';
import pkg from '../../package.json';

/**
 * Validates the schema of a JoyDoc document.
 *
 * @param {Object} doc - The JoyDoc document to validate.
 * @returns {Object|undefined} - Returns an error object if validation fails, otherwise undefined.
 */

const validateSchema = (doc) => {
  const { $joyfillSchemaVersion } = JoyDocSchemaJson;
  const { version: sdkVersion } = pkg;


  const passedSchemaVersion = doc?.v || '1.0.0';

  const schemaErrorObject = {
    code: 'ERROR_SCHEMA_VALIDATION',
    message: 'Error detected during schema validation',
    details: {
      schemaVersion: $joyfillSchemaVersion,
      sdkVersion,
    }
  };

  const schemaVersionErrorObject = {
    code: 'ERROR_SCHEMA_VERSION',
    message: 'Error detected with targeted schema version.',
    error: `The targeted version of ${passedSchemaVersion} is not supported. Version ${$joyfillSchemaVersion} must be used.`,
    details: {
      schemaVersion: $joyfillSchemaVersion,
      sdkVersion,
    }
  };

  // Validate schemaVersion
  const isVersionCompatible = compareVersions($joyfillSchemaVersion, passedSchemaVersion);

  if (!isVersionCompatible) {
    return schemaVersionErrorObject;
  }

  const valid = validate(doc);


  if (!valid) {
    return {
      ...schemaErrorObject,
      errors: validate.errors
    };
  }

  // If validation passes, return undefined
  return undefined;
};

export default validateSchema;

/**
 * Compares the current version of the JoyDoc schema with the passed version.
 * Returns true if they are compatible, false otherwise.
 *
 * @param {string} currentVersion - The current version of the JoyDoc schema.
 * @param {string} passedVersion - The version to compare against.
 * @returns {boolean} - True if versions are compatible, false otherwise.
 */

const compareVersions = (currentVersion, passedVersion) => currentVersion.split('.')[0] === passedVersion.split('.')[0];
